import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "@/config/customBaseQuery";

export const companyApi = createApi({
    reducerPath: "companyApi",

    baseQuery: customBaseQuery,

    tagTypes: ["CompanyDropdown"],

    endpoints: (builder) => ({
        getCompanyDropdownList: builder.query({
            query: () => ({
                url: "v1/CompanySetup/GetCompanyDropdownList",
                method: "GET",
            }),


            transformResponse: (response) => {
                return response?.data ?? [];
            },

            providesTags: ["CompanyDropdown"],

            keepUnusedDataFor: 600,
        }),
    }),
});

export const {
    useGetCompanyDropdownListQuery,
} = companyApi;